/*
 * Returns the full name of a contact entity.
 */
export function contactToFullName(contact: {
  firstName?: string | null;
  lastName?: string | null;
  middleNames?: string | null;
  companyName?: string | null;
}): string {
  // Check
  if (!contact) {
    return '';
  }

  return contact.companyName
    ? `${contact.companyName.trim().replace(/\s+/g, ' ')}`
    : `${
        contact.firstName ? contact.firstName.trim().replace(/\s+/g, ' ') : ''
      }` +
        `${
          contact.middleNames
            ? ' ' + contact.middleNames.trim().replace(/\s+/g, ' ')
            : ''
        }` +
        `${
          contact.lastName
            ? ' ' + contact.lastName?.trim().replace(/\s+/g, ' ')
            : ''
        }`;
}
